module.exports = __webpack_public_path__ + "img/media_1.87d36247.webp";